export default __webpack_public_path__ + "static/media/shopping_cart.b5c90f67.svg";